class SSOProvider {
    id: number;
    schoolID: number;
    login: string;
    logout: string;
    fingerprint: string;
    matchOn: string;

    constructor(data?: Partial<SSOProvider>) {
        this.login = "";
        this.logout = "";
        this.matchOn = "EmailAddress";

        Object.assign(this, data);
    }
}

export default SSOProvider;
